export default __webpack_public_path__ + "static/media/team_lores.584af5d7.png";